import pick from 'lodash/pick.js'

import {reportSelector} from '../../../data/reports.js'
import {
  formSelector,
  getState,
  updateForm,
  useForm,
  useSelector,
} from '../../../store.js'
import DateFilters, {
  dateFilterErrorsSelector,
  dateFilterPayloadV2ParamsSelector,
} from './DateFilters.js'
import {defaultWarehouseSelector} from '../../../data/warehouses.js'
import {WarehouseSelect} from '../../../common/components/WarehouseSelect.js'

export function setupExportInventoryEventsForm(params = {}) {
  let {reportID, warehouseID} = params
  params = pick(params, ['sku'])
  const warehouse = defaultWarehouseSelector(getState())

  const {params: reportParams} = reportID
    ? reportSelector(getState(), {reportID})
    : {params: {}}

  return {
    warehouseID: reportParams.warehouse_id || warehouseID || warehouse.id,
    ...params,
  }
}

export function exportInventoryEventsErrorsSelector(state, {formName}) {
  const errors = {...dateFilterErrorsSelector(state, {formName})}

  return errors
}

export function exportInventoryEventsPayloadSelector(state, {formName}) {
  const {reportType, sku, warehouseID} = formSelector(state, {formName})

  const dateParams = dateFilterPayloadV2ParamsSelector(state, {
    formName,
    prepend: 'updated_',
  })

  const payload = {
    type: reportType,
    params: {
      sku,
      warehouse: warehouseID,
      ...dateParams,
    },
  }

  return payload
}

export default function ExportInventoryEventsForm({formName}) {
  const form = useForm(formName)
  const errors = useSelector((state) =>
    exportInventoryEventsErrorsSelector(state, {formName}),
  )

  return (
    <ul className="list list--no-style">
      <li className="list__item--form list__item--no-style">
        <p className="fs-00 margin-top-20 margin-bottom-10">
          <strong>SKU: {form.sku}</strong>
        </p>
      </li>
      <li className="list__item--form list__item--no-style">
        <WarehouseSelect
          value={form.warehouseID}
          onChange={(warehouse) =>
            updateForm(formName, {warehouseID: warehouse.id})
          }
        />
      </li>
      <DateFilters formName={formName} errors={errors} />
    </ul>
  )
}
